module.exports = __webpack_public_path__ + "static/img/default_yegw_bg.4d750ea8.jpg";